﻿export class Dimension {
    feet: number = -1;
    inches: number = -1;
}